import { useStaticQuery, graphql } from "gatsby";

const useSiteMetadata = (): JQI.SiteMetadata => {
  const { site } = useStaticQuery(
    graphql`
      query {
        site {
          siteMetadata {
            title
            siteUrl
            groupId
            isGroup
            description
          }
        }
      }
    `
  );
  return site.siteMetadata;
};

export default useSiteMetadata;